import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaSave } from 'react-icons/fa';
import Swal from 'sweetalert2';
import { ACTIVIDADES_LABORALES } from '../../utils/licenciasMedicas';
import '../../styles/pages/RRHH/ParametrosEmpresaPage.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

/**
 * Página de Parámetros de Empresa
 * Configuración de datos para RRHH
 */
const ParametrosEmpresaPage = ({ token, id_company }) => {
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({
        nombre_mutual: '',
        tasa_mutual: '',
        nombre_ccaf: '',
        actividad_laboral_lme: ''
    });

    // Opciones de Mutualidades en Chile (códigos Previred)
    const mutualesOptions = [
        { value: '', label: 'Seleccione una opción' },
        { value: '00', label: '00 - Sin Mutual (ISL)' },
        { value: '01', label: '01 - Asociación Chilena de Seguridad (ACHS)' },
        { value: '02', label: '02 - Mutual de Seguridad CCHC' },
        { value: '03', label: '03 - Instituto de Seguridad del Trabajo (IST)' }
    ];

    // Opciones de Cajas de Compensación en Chile
    const cajasOptions = [
        { value: '', label: 'Seleccione una Caja' },
        { value: 'LOS ANDES', label: 'Caja Los Andes' },
        { value: 'LA ARAUCANA', label: 'Caja La Araucana' },
        { value: '18 DE SEPTIEMBRE', label: 'Caja 18 de Septiembre' },
        { value: 'LOS HEROES', label: 'Caja Los Héroes' }
    ];

    useEffect(() => {
        fetchParametros();
    }, []);

    const fetchParametros = async () => {
        try {
            setLoading(true);
            const response = await axios.get(
                `${API_BASE_URL}/api/rrhh/parametros/${id_company}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.data.success && response.data.data) {
                setFormData(response.data.data);
            }
        } catch (error) {
            console.error('Error al cargar parámetros:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post(
                `${API_BASE_URL}/api/rrhh/parametros`,
                { ...formData, id_company },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.data.success) {
                Swal.fire('Éxito', 'Parámetros guardados correctamente', 'success');
            }
        } catch (error) {
            console.error('Error al guardar parámetros:', error);
            Swal.fire('Error', error.response?.data?.message || 'Error al guardar', 'error');
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    if (loading) {
        return <div className="loading">Cargando parámetros...</div>;
    }

    return (
        <div className="parametros-container">
            <div className="parametros-header">
                <h1>Parámetros de Empresa</h1>
                <p>Configuración general para Recursos Humanos</p>
            </div>

            <form onSubmit={handleSubmit} className="parametros-form">
                <div className="form-section">
                    <h2>Mutual de Seguridad</h2>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Mutual</label>
                            <select
                                name="nombre_mutual"
                                value={formData.nombre_mutual || ''}
                                onChange={handleChange}
                                className="form-select"
                            >
                                {mutualesOptions.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Tasa Mutual (%)</label>
                            <input
                                type="number"
                                step="0.01"
                                name="tasa_mutual"
                                value={formData.tasa_mutual || ''}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                </div>

                <div className="form-section">
                    <h2>Caja de Compensación</h2>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Caja de Compensación</label>
                            <select
                                name="nombre_ccaf"
                                value={formData.nombre_ccaf || ''}
                                onChange={handleChange}
                                className="form-select"
                            >
                                {cajasOptions.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>

                <div className="form-section">
                    <h2>Licencias Médicas</h2>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Actividad laboral de la empresa</label>
                            <select
                                name="actividad_laboral_lme"
                                value={formData.actividad_laboral_lme ?? ''}
                                onChange={handleChange}
                                className="form-select"
                            >
                                <option value="">Seleccione una opción</option>
                                {ACTIVIDADES_LABORALES.map(actividad => (
                                    <option key={actividad.valor} value={actividad.valor}>
                                        {actividad.valor} - {actividad.nombre}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>

                <div className="form-actions">
                    <button type="submit" className="btn-save">
                        <FaSave /> Guardar Parámetros
                    </button>
                </div>
            </form>
        </div>
    );
};

export default ParametrosEmpresaPage;
